// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JgWb","top":"styles_top__QcIJb","left":"styles_left__1URxk","description":"styles_description__10y2c"};